import {ScoreConfig} from "../components";
import Layout from "../components/Layout";

export default function Score() {

  return (
    <div>
        <Layout />
        <div>
            <ScoreConfig />
        </div>
    </div>
  );
}